/* eslint-disable import/no-import-module-exports */
/* Import Leverege Modules */
import { Plugins } from '@leverege/plugin';

/* Import Local I18nResolvers */
import BooleanI18nResolver from "./BooleanI18nResolver.js";
import BooleanI18nResolverModel from "./BooleanI18nResolverModel.js";
/**
 * Installs i18nResolver plugins.
 */
export default {
  install: () => {
    // Add boolean plugins
    Plugins.add('AttributeI18nResolver', {
      type: BooleanI18nResolverModel.TYPE,
      resolver: BooleanI18nResolver
    });
    Plugins.add('Model', {
      type: BooleanI18nResolverModel.TYPE,
      model: BooleanI18nResolverModel
    });
  }
};